import BudgetedLastMonthTip from './budgeted-last-month';
import SpentLastMonthTip from './spent-last-month';
import BudgetedAverageTip from './budgeted-average';
import SpentAverageTip from './spent-average';

/** @type Array<BaseTip> */
export default [
    BudgetedLastMonthTip,
    SpentLastMonthTip,
    BudgetedAverageTip,
    SpentAverageTip
];
